"use strict";
/**
 * @module Services.Timeseries
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link TimeSeriesTimestampAppendRequest}
 */
var TimeSeriesTimestampAppendRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(TimeSeriesTimestampAppendRequestSerialiserClass, _super);
    function TimeSeriesTimestampAppendRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TimeSeriesTimestampAppendRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TimeSeriesTimestampAppendRequest} to be written
     */
    TimeSeriesTimestampAppendRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        Codec.writeString(bos, value.dataType.name());
        Codec.writeBytes(bos, value.value);
        Codec.writeInt64(bos, value.timestamp);
    };
    return TimeSeriesTimestampAppendRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TimeSeriesTimestampAppendRequestSerialiserClass = TimeSeriesTimestampAppendRequestSerialiserClass;
/**
 * The {@link TimeSeriesTimestampAppendRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TimeSeriesTimestampAppendRequestSerialiser = new TimeSeriesTimestampAppendRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/time-series-timestamp-append-request-serialiser.js
// module id = 1647
// module chunks = 1